import { useMemo } from "react"
import { Box, Container, Skeleton } from "@mui/material"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

import { selectCurrentOrgId } from "features/store/orgSlice"
import useDevices from "helpers/hooks/useDevices"
import useDocumentTitle from "helpers/hooks/useDocumentTitle"
import { DASHBOARD_PADDING, FOOTER_HEIGHT, NAVBAR_HEIGHT } from "helpers/utils/constants"
import Map from "widgets/plots/geo/Map"
import GeoJSONLayers from "widgets/plots/geo/GeoJSONLayers"
import { getMapCenterFromGeo } from "helpers/utils/map"
import useGeolocations from "helpers/hooks/useGeolocations"

const MainMap = () => {
  const { t } = useTranslation()
  const orgId = useSelector(selectCurrentOrgId)
  const { geoData, isFetching: geoFetching } = useGeolocations()
  const { isFetching: devicesFetching } = useDevices()

  useDocumentTitle(t("pageTitles.MAP"))

  const center = useMemo(() => getMapCenterFromGeo(geoData), [geoData])

  return (
    <>
      <Box
        sx={{
          width: `100%`,
          height: `calc(100vh - ${NAVBAR_HEIGHT}px - ${FOOTER_HEIGHT}px)`,
          position: "relative",
          mt: `-${DASHBOARD_PADDING}`,
        }}
      >
        <Container
          disableGutters
          maxWidth={false}
          sx={{
            height: "100%",
            width: "100%",
            position: "absolute",
          }}
        >
          {!geoFetching && !devicesFetching ? (
            <Map
              center={center}
              key={orgId}
              mapHeight="100%"
              enableInteractionOverlay={false}
            >
              <GeoJSONLayers data={geoData} collapsed={false} />
            </Map>
          ) : (
            <Skeleton variant="rectangular" height="100%" />
          )}
        </Container>
      </Box>
    </>
  )
}

export default MainMap
